import { DiagnosticFilter } from "../diagnostic-filter";
import { Entity, Plan } from "../entity";
import { IntegratedOrderConf } from "../integrated-admission/integrated-order-conf";
import { ReferringPhysicianFilter } from "../referring-physician";
import { ReferringPhysicianInstituteFilter } from "../referring-physician-institute-filter";

export class MedicalAppointmentOrderAuditing {
  OrderId: number;
  ReferringPhysician: ReferringPhysicianFilter;
  ReferringPhysicianInstitute: ReferringPhysicianInstituteFilter;
  MemberNumber: string;
  PreAuthorizationNumber: string;
  Diagnostic: DiagnosticFilter;
  OrderDate?: Date;
  Observations: string;
  OrderConf: IntegratedOrderConf;
  Entity: Entity;
  Plan: Plan;
}
